// import firebase from 'firebase'
// import { getFirestore } from "firebase/firestore";

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const config = {
  apiKey: "AIzaSyAWPzue15u4PZlzwyEcWwWhnumt84lQPtA",
  authDomain: "inventory-308102.firebaseapp.com",
  projectId: "inventory-308102",
  messagingSenderId: "79789578776",
  appId: "1:79789578776:web:c4c9fb80b3e80ac6ee816d",
  databaseURL: "https://inventory-308102-default-rtdb.firebaseio.com"
}

const App = initializeApp(config);

// export function firebaseListener(func) {

//     if (onAuthStateChanged.user) {
//       //console.log("User log in success", user);
//       // user.getIdToken().then(function(idToken) {  // <------ Check this line
//       //   console.log(idToken); // It shows the Firebase token now
//       // })
//       func(true, onAuthStateChanged.user)
//     } else {
//       // console.log("User log in failed", user);
//       func(false)
//     }
// }

// export function firebaseListener(func) {
//   //firebase.auth().onAuthStateChanged(function(user) {
//   onAuthStateChanged(function(user) {
//     if (user) {
//       //console.log("User log in success", user);
//       // user.getIdToken().then(function(idToken) {  // <------ Check this line
//       //   console.log(idToken); // It shows the Firebase token now
//       // })
//       func(true, user)
//     } else {
//       // console.log("User log in failed", user);
//       func(false)
//     }
//   }, function(error) {
//     console.log(error)
//   });
// }

export const DB = getFirestore(App)
//export const ref = firebase.database().ref();
export const ref = null
export const firebaseAuth = getAuth(App);

// onAuthStateChanged(firebaseAuth, user => {
//   console.log(user)
// 	if (store) {
// 		store.commit('AUTH_STATUS_CHANGE');
// 	}
//   // Check for user status
// });


